import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input del Design System: alto 36px, radio 8, borde #E4E4E7 y focus con el
 * ring teal claro #9FDCD3.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-input bg-background placeholder:text-soft selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-lg border px-[11px] text-[13px] transition-colors outline-none",
        "hover:border-border-strong",
        "file:text-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-[13px] file:font-medium",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        className
      )}
      {...props}
    />
  )
}

export { Input }
